import {GridModel, GridRequest} from '../../shared/grid/grid.model';
import {GridConfiguration} from '../../shared/helpers/dx-grid-helper';
export class ApplicantModel extends GridModel {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  doB: Date;
  gender: string;
  genderString: string;
  industry: string;
  otherIndustry?: any;
  industryString: string;
  university?: any;
  employer?: any;
  employerOrUniversityString: string;
  jobRole: string;
  status: string;
  statusString: string;
  registrationDate: Date;
  lookupInvitedById?: any;
  lookupInvitedByFullName?: any;
}


export class ApplicantAnalyticsModel {
  name: string;
  singleValue: boolean;
  data: string;
}


export class ApplicantRequestModel extends GridRequest {
  status: string;
  reReview: boolean;
}

export class ApplicantGridConfiguration extends GridConfiguration {

  constructor() {
    super();
    this.columns = [
      {
        dataField: 'registrationDate',
        caption: 'Date applied',
        dataType: 'date',
        format: 'dd/MM/yyyy'
      },
      'firstName',
      'lastName',
      'email',
      {
        dataField: 'doB',
        caption: 'DOB',
        dataType: 'date',
        format: 'dd/MM/yyyy'
      },
      'gender',
      'industry',
      {
        dataField: 'employerOrUniversityString',
        caption: 'Employer / Uni',
      },
      {
        dataField: 'jobRole',
        caption: 'Role',
      },
      {
        dataField: 'lookupInvitedByFullName',
        caption: 'Invited By',
      },
      {
        dataField: 'statusString',
        caption: 'Status',
      },
      {
        cellTemplate: 'deleteButton'
      }
    ];

    this.customSearch = [
      {
        fieldName: 'firstName',
        value: ''
      },
      {
        fieldName: 'lastName',
        value: ''
      }
    ];
    this.selection = {
      mode: 'none',
      allowSelectAll: false
    };
    this.sorting = { mode: 'none' };
  }

  mapGridRequest(gridRequest: GridRequest, loadOptions: any) {
    super.mapGridRequest(gridRequest, loadOptions);
    gridRequest.options.customSearch = this.customSearch;
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/application-management/application-management.model.ts